import {BaseFormModel} from './base-form-model';
import {Organization} from './organization';
import {Address} from './address';
import {OrganizationEvent} from './organization-event';
import {DonationProgram} from './donation-program';

export class PickupLocation extends BaseFormModel<PickupLocation> {
    id: number;
    organization: Organization;
    name: string;
    phone: string;
    direction: string;
    imageAddress: string;
    availableMarkers: string;
    address: Address;
    status: string;
    mobile: boolean;
    autoPrintClaim: boolean;
    orderPrintOption: string;
    orderNavigation: string;
    activeEvent: OrganizationEvent;
    activeDonationProgram: DonationProgram;
    parentPickupLocation: PickupLocation;

    orgId: number;
    organizationName: string;
    organizationLogo: string;
    distance: number;
    latitude: number;
    longitude: number;
}
